<st-recommendation-panel [success]="!inProgress" [withPadding]="false">
  <div class="content tw-flex tw-rounded-lg tw-grow" [class.learning]="learning" (click)="openRecommendedResource()">
    <div class="tw-flex tw-flex-col tw-grow tw-gap-0.5 tw-p-2.5">
      <div *ngIf="waitingForReward; else learningBlock" class="tw-flex tw-items-center tw-gap-2">
        <span class="tw-italic" translate>student.recommendation.labels.waiting_for_reward</span>
        <kendo-loader class="tw-text-base-text/[.65]" type="pulsing" size="small"></kendo-loader>
      </div>
      <ng-template #learningBlock>
        <span *ngIf="learning; else learnBlock" class="tw-italic" translate>student.recommendation.labels.in_progress</span>
        <ng-template #learnBlock>
          <span class="tw-font-medium">{{ title$ | async }}</span>
        </ng-template>
      </ng-template>
      <hr>
      <div class="tw-flex tw-items-center">
        <img
          src="{{ assetsPath$ | async }}/icons/{{ inProgress ? 'IXL_dark' : 'IXL_white' }}.svg"
          class="tw-mr-2 tw-rounded-md tw-w-6 tw-h-6 tw-text-xl"
        />
        <span class="tw-flex tw-items-center tw-font-medium">
          <span>- {{ subtitle$ | async }}</span>
        </span>
      </div>
      <div class="tw-text-sm" [class.tw-font-light]="!inProgress">{{ name$ | async }}</div>
    </div>
    <div
      [ngClass]="{ 'tw-bg-neutral-300': inProgress, 'tw-bg-white/20': !inProgress }"
      class="earn-section tw-flex tw-flex-col tw-items-center tw-gap-0.5 tw-p-2.5 "
    >
      <span class="tw-font-medium" translate>student.recommendation.labels.earn</span>
      <hr>
      <span class="tw-flex tw-justify-center tw-items-center tw-grow tw-font-medium tw-text-xl">
        {{ currencySign$ | async }}{{ reward }}
      </span>
    </div>
    <div class="tw-flex tw-justify-center tw-items-center tw-p-2.5 tw-text-lg">
      <fa-icon class="arrow-icon" [class.tw-invisible]="inProgress" [icon]="icons.faAngleRight"></fa-icon>
    </div>
  </div>
</st-recommendation-panel>
